import { httpService } from '../../../http-service/httpService';
import {
  axiosTimeoutConfig,
  DATA_FETCH_ERROR,
  FORCED_CANCELLATION,
  FORCED_CANCELLATION_MESSAGE,
  REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS,
  REVIEW_AND_SUBMIT_CONFIG,
  REVIEW_AND_SUBMIT_ERROR,
  REVIEW_AND_SUBMIT_LOADING,
  REVIEW_AND_SUBMIT_STEP_1_DATA,
  SET_REVIEW_AND_SUBMIT_BTN_DISPLAY,
} from '../types';
import {
  URL_LOCK_API,
  URL_LOCK_CONSULTEE_API,
  URL_LOCK_SUMMARY_API,
  URL_VALIDATE_SIGNATURE_API,
} from '../urls';

export const setReviewAndSubmitLoading = (status) => (dispatch) => {
  dispatch({
    type: REVIEW_AND_SUBMIT_LOADING,
    payload: status,
  });
};

export const setIsSubmittingReviewAndSubmit = (status) => (dispatch) => {
  dispatch({
    type: SET_REVIEW_AND_SUBMIT_BTN_DISPLAY,
    payload: status,
  });
};

export const setReviewAndSubmittingState = (status) => (dispatch) => {
  dispatch({
    type: REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS,
    payload: status,
  });
};

export const setReviewAndSubmitConfig = (configObject) => (dispatch) => {
  dispatch({
    type: REVIEW_AND_SUBMIT_CONFIG,
    payload: configObject,
  });
};

export const getReviewAndSubmitStep1Data =
  (certkey, groupBy) => async (dispatch, getState) => {
    const { isLoadingReviewAndSubmit } = getState().certifications.details;

    const body = {
      certkey,
      group_by: groupBy,
    };

    if (!isLoadingReviewAndSubmit) {
      dispatch({ type: REVIEW_AND_SUBMIT_LOADING, payload: true });
    }

    dispatch({
      type: REVIEW_AND_SUBMIT_ERROR,
      payload: { isError: false, error: null },
    });

    try {
      const { data } = await httpService.post(
        URL_LOCK_SUMMARY_API,
        body,
        axiosTimeoutConfig
      );

      const { response, Summary } = data;

      dispatch({
        type: REVIEW_AND_SUBMIT_STEP_1_DATA,
        payload: {
          results: { [groupBy]: response === 'Success' ? Summary : null },
          error: 'null',
        },
      });

      return REVIEW_AND_SUBMIT_STEP_1_DATA;
    } catch (error) {
      if (error?.code !== FORCED_CANCELLATION) {
        dispatch({
          type: REVIEW_AND_SUBMIT_STEP_1_DATA,
          payload: {
            results: {},
            error: DATA_FETCH_ERROR,
          },
        });
      }

      dispatch({
        type: REVIEW_AND_SUBMIT_ERROR,
        payload: {
          isError: error?.code !== FORCED_CANCELLATION,
          error:
            error?.code === FORCED_CANCELLATION
              ? FORCED_CANCELLATION_MESSAGE
              : DATA_FETCH_ERROR,
        },
      });

      throw Error(error);
    }
  };

export const validateESignature =
  (certkey, eSignatureLogin, noOfTries, payload) =>
  async (dispatch, getState) => {
    const { isSubmittingReviewAndSubmit } = getState().certifications.details;

    const body = {
      certkey,
      eSignatureLogin,
      noOfTries,
      ...payload,
    };

    if (!isSubmittingReviewAndSubmit) {
      dispatch({ type: REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS, payload: true });
    }

    try {
      const { data } = await httpService.post(
        URL_VALIDATE_SIGNATURE_API,
        body,
        axiosTimeoutConfig
      );

      const { response, validateESignature: validateESignatureStatus } = data;

      if (
        validateESignatureStatus === undefined ||
        validateESignatureStatus === null ||
        !validateESignatureStatus
      ) {
        throw response;
      }

      return response;
    } catch (error) {
      throw Error(error);
    }
  };

export const lockReviewAndSubmit =
  (certkey, lockComments) => async (dispatch, getState) => {
    const { isSubmittingReviewAndSubmit } = getState().certifications.details;

    const body = {
      certkey,
      lockComments,
      requestOrigin: 'UI',
    };

    if (!isSubmittingReviewAndSubmit) {
      dispatch({ type: REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS, payload: true });
    }

    try {
      const { data } = await httpService.post(URL_LOCK_API, body);

      const { response, lockSuccessfull } = data;

      if (
        lockSuccessfull === undefined ||
        lockSuccessfull === null ||
        !lockSuccessfull
      ) {
        throw response;
      }

      return response;
    } catch (error) {
      throw Error(error);
    }
  };

export const lockReviewAndSubmitForConsultee =
  (certkey) => async (dispatch, getState) => {
    const { isSubmittingReviewAndSubmit } = getState().certifications.details;

    const body = {
      certkey,
      requestOrigin: 'UI',
    };

    if (!isSubmittingReviewAndSubmit) {
      dispatch({ type: REVIEW_AND_SUBMIT_BTN_SUBMIT_PRESS, payload: true });
    }

    try {
      const { data } = await httpService.post(
        URL_LOCK_CONSULTEE_API,
        body,
        axiosTimeoutConfig
      );

      const { consultComplete } = data;

      if (
        consultComplete === undefined ||
        consultComplete === null ||
        !consultComplete
      ) {
        throw Error('Unable to complete this certification at the moment');
      }

      return 'Success';
    } catch (error) {
      throw Error(error);
    }
  };
